import type { InjectionKey } from 'vue'

import type { RetryFunction } from './retry-function'

export const ON_RETRY_INJECTION_KEY = Symbol('onRetry') as InjectionKey<
  (fn: RetryFunction) => void
>
